// Styles
import Styles from "./Styles/Comment.module.css";
// Images
import personImage from "../../../Assets/Images/person.png";

const Comment = ({ comment, username }) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.author}>
        <div className={Styles.imageContainer}>
          <img src={personImage} alt="" />
        </div>
        <h5>{username}</h5>
      </div>
      <div className={Styles.content}>{comment}</div>
    </div>
  );
};

export default Comment;
